import './App.css';
import ProjectHolder from './ProjectHolder.js'
function App() {
  return (
    <div className="App">
      <ProjectHolder/>
    </div>
  );
}

export default App;
